export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_view_team',
  'contact_manage',
  'contact_assigned_view',
  'label_manage',
  'campaign_manage',
  'knowledge_base_manage',
  'whatsapp_template_edit',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_view_team',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONVERSATION_VIEW_TEAM_PERMISSION = 'conversation_view_team';

export const TEAM_MANAGEMENT_PERMISSION = 'team_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const CONTACT_ASSIGNED_VIEW_PERMISSION = 'contact_assigned_view';

export const LABEL_MANAGEMENT_PERMISSION = 'label_manage';

export const CONTACT_READ_PERMISSIONS = [
  CONTACT_PERMISSIONS,
  CONTACT_ASSIGNED_VIEW_PERMISSION,
];

export const CAMPAIGN_PERMISSIONS = 'campaign_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const TEAM_REPORTS_PERMISSION = 'report_view_team';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const WHATSAPP_TEMPLATE_EDIT_PERMISSION = 'whatsapp_template_edit';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
      CONVERSATION_VIEW_TEAM_PERMISSION,
    ],
  },
};
